import { createApp } from 'vue'
import App from './App.vue'
import Keycloak from 'keycloak-js'
import { ApmVuePlugin } from '@elastic/apm-rum-vue'

// plugins
import vuetify from './plugins/vuetify'
import { i18n } from './plugins/vue-i18n'
import "./plugins/vee-validate";

// Telekom Scale UI library
import { defineCustomElements } from '@telekom/scale-components/loader';
import '@telekom/scale-components/dist/scale-components/scale-components.css';
defineCustomElements();

// Import the ApmVuePlugin from Elastic APM

const app = createApp(App)

const renderApp = () => {
  app.use(vuetify).use(i18n).use(ApmVuePlugin, {
    config: {
      serviceName: 'user-self-service-ui',
      serverUrl: window.__CONFIG__.APM_URL,
      environment: window.__CONFIG__.APM_ENV,
    }
  }).mount('#app')
}

// Uncomment the next block of code when you want to run the project locally and put the token from the dev environment 
// to the token field.

/* DEVELOPMENT ONLY*/
// const keycloakDevInstance = {
//   isDevelopmentEnv: true,
//   token: ''
// }
// app.provide('keycloak', keycloakDevInstance)

// renderApp();

// Keycloak
let keycloakInitOptions = {                              
  url: window.__CONFIG__.KEYCLOAK_URL,
  realm: window.__CONFIG__.REALM,
  clientId: window.__CONFIG__.CLIENT_ID
};
let keycloak = new Keycloak(keycloakInitOptions);

keycloak.init({ onLoad: 'login-required' })
  .then((auth) => {
    if (!auth) {
      window.location.reload();
    } else {
      app.provide('keycloak', keycloak)
      renderApp();
    }
    //Token Refresh
    setInterval(() => {
      keycloak.updateToken(70)
        .catch((err) => {
          console.log('Failed to refresh token -> ', err);
        });
    }, 5000)
  })
  .catch(err => {
    console.log('Authentication failed -> ', err)
  });

